import { DialogModule } from '@angular/cdk/dialog';
import { DatePipe, Location, ViewportScroller } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { LoginService } from 'app/login.service';
import { Article } from 'app/models/Article';
import { MarketData } from 'app/models/MarketData';
import { Utilisateur } from 'app/models/Utilisateur';
import { PopupLoginComponent } from 'app/modules/popup-login/popup-login.component';
import { ArticleSchemaService } from 'app/shared/ArticleSchema.service';
import { LinkService } from 'app/shared/Link.service';
import { ArticleService } from 'app/shared/article.service';
import { ConvertToSlugPipe } from 'app/shared/convert-to-slug.pipe';
import { DataService } from 'app/shared/data.service';
import { MetaService } from 'app/shared/meta.service';
import { SharedModule } from 'app/shared/shared.module';
import { UtilisateurService } from 'app/shared/utilisateur.service';
import { isToday } from 'app/utils/date.utils';
import { environment } from 'environments/environment';
import { Subject, takeUntil } from 'rxjs';
import { PopupWatchlistComponent } from '../../popup-watchlist/popup-watchlist.component';

@Component({
    selector: 'app-liste-news',
    templateUrl: './liste-news.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MatButtonModule,
        DialogModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatTooltipModule,
        SharedModule,
        MatPaginatorModule,
        MatTableModule,
        RouterModule,
        ConvertToSlugPipe,
    ],
    providers: [DatePipe],
})
export class ListeNewsComponent implements OnInit, OnDestroy {
    serveur_name = environment.serveur_name;
    host_name = environment.host_name;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    nbNews: number;
    listeNews: Article[];
    watchlist: boolean = false;
    populaires: boolean = true;
    displayedColumns: string[] = ['Trouver un actif', 'Watchlist'];
    displayedColumns1: string[] = ['Trouver un actif', 'Watchlist'];
    public dataSource1 = new MatTableDataSource<MarketData>();
    public dataSource = new MatTableDataSource<MarketData>();
    user: Utilisateur;
    actifs: MarketData[] = [];
    totalPages: number = 0;
    currentPage: number = 0;
    pageSize: number = 10;
    loadingNews: boolean = true; // Add this variable to track loading state

    constructor(
        private articleService: ArticleService,
        public location: Location,
        private _changeDetectorRef: ChangeDetectorRef,
        private router: Router,
        private dataService: DataService,
        public dialog: MatDialog,
        private scroll: ViewportScroller,
        private utilisateurService: UtilisateurService,
        private loginService: LoginService,
        private articleSchemaService: ArticleSchemaService,
        private seoService: LinkService,
        private metaService: MetaService,
        private datePipe: DatePipe
    ) {}
    yesterday = ((d) => new Date(d.setDate(d.getDate() - 1)))(new Date());
    formatDate(date): string {
        const created = this.datePipe.transform(date, 'yyyy-MM-ddTHH:mm');
        let fecha = new Date(created);
        let today = new Date();
        let yesterday = ((d) => new Date(d.setDate(d.getDate() - 1)))(
            new Date()
        );
        if (isToday(today, fecha))
            return this.datePipe.transform(fecha, 'H:mm');
        if (isToday(yesterday, fecha)) return 'Hier';
        return this.datePipe.transform(fecha, 'd MMMM ');
    }

    ngOnInit() {
        this.chargerNews();
        this.recupererWatchlist();
        this.recupererPopulaires();
        this.createLinkForCanonicalURL();
        this.metaService.updateMetaTags({
            title: 'News financières, boursières et économiques',
            description:
                "Le média incontournable pour suivre l'actualité boursiére et financière tunisienne et internationale. Analyses de marché, indices, actions, devises et matières premières",
            canonicalLink: environment.apiUrl + '/actualites/news',
            keywords:
                'Bourse de Tunis, finance, résumé de marché, investissement, actions, devises, matières premières, analyse technique, analyse fondamentale, économie, inflation, cotation',
            ogTitle: 'News financières, boursières et économiques',
            ogUrl: environment.apiUrl + '/actualites/news',
            ogDescription:
                "Le média incontournable pour suivre l'actualité boursiére et financière tunisienne et internationale. Analyses de marché, indices, actions, devises et matières premières",
            twitterTitle: 'News financières, boursières et économiques',
            twitterDescription:
                "Le média incontournable pour suivre l'actualité boursiére et financière tunisienne et internationale. Analyses de marché, indices, actions, devises et matières premières",
        });
        // Générer les schémas structurés
        this.articleSchemaService.generateGlobalWebPageSchema({
            url: environment.apiUrl + '/actualites/news',
            name: 'News financières, boursières et économiques',
            description:
                "Le média incontournable pour suivre l'actualité boursiére et financière tunisienne et internationale. Analyses de marché, indices, actions, devises et matières premières",
            isPartOf: {
                name: 'Irbe7',
                url: environment.apiUrl,
            },
        });
    }
    createLinkForCanonicalURL() {
        this.seoService.createLinkForCanonicalURL();
    }

    chargerNews(page: number = 0, size: number = 10) {
        this.loadingNews = true; // Set loading state to true before making the API call

        this.articleService
            .getNewsPaginate(this.currentPage, this.pageSize)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (response) => {
                    // Convertir l'objet en tableau de news
                    const newsArray = Object.values(response.content);
                    this.totalPages = response.totalPages;
                    // Trier le tableau par ordre chronologique
                    newsArray.sort((a, b) => {
                        return (
                            new Date(b.date).getTime() -
                            new Date(a.date).getTime()
                        );
                    });

                    // Assigner la liste triée à la variable
                    this.listeNews = newsArray;

                    // Mettre à jour le nombre de news
                    this.nbNews = newsArray.length;

                    this.loadingNews = false; // Set loading state to true before making the API call

                    // Mark for check
                    this._changeDetectorRef.markForCheck();
                },
                error: (err) => {
                    (error) => console.log(error);
                    this.loadingNews = false; // Set loading state to true before making the API call
                },
            });
    }
    onPageChange(page: number) {
        this.currentPage = page;
        this.chargerNews();
        this.scroll.scrollToPosition([0, 0]);
    }
    totalPagesArray(): number[] {
        return Array.from({ length: this.totalPages }, (_, index) => index);
    }
    redirectFormation() {
        if (typeof window !== 'undefined') {
            const formationUrl = 'https://formation.irbe7.com/formations/';
            window.open(formationUrl, '_blank');
        }
    }
    retour() {
        this.location.back();
    }
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }
    recupererWatchlist() {
        let array: MarketData[] = [];
        this.dataService
            .recupererTout()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (data: MarketData[]) => {
                    this.utilisateurService
                        .getUtilisateurByUsername(
                            this.loginService.getUsername()
                        )
                        .pipe(takeUntil(this._unsubscribeAll))
                        .subscribe({
                            next: (user: Utilisateur[]) => {
                                if (this.loginService.getIsLogged()) {
                                    this.user = user[0];
                                    this.user.watchlist =
                                        this.user.watchlist || [];

                                    for (let i = 0; i < data.length; i++) {
                                        for (
                                            let j = 0;
                                            j < this.user.watchlist.length;
                                            j++
                                        ) {
                                            if (
                                                data[i].referentiel.stockName ==
                                                this.user.watchlist[j]
                                            ) {
                                                array.push(data[i]);
                                            }
                                        }
                                    }
                                    this.dataSource1.data = array;
                                    this._changeDetectorRef.markForCheck();
                                }
                            },
                        });
                    this._changeDetectorRef.markForCheck();
                },
            });
    }

    recupererPopulaires() {
        this.dataService
            .recupererIndices()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (data: MarketData[]) => {
                    this.actifs = data;
                    let array = data.filter(
                        (a) =>
                            a.referentiel.stockName == 'TUNINDEX20' ||
                            a.referentiel.stockName == 'TUNINDEX'
                    );
                    this.dataService
                        .recupererPrincipaux()
                        .pipe(takeUntil(this._unsubscribeAll))
                        .subscribe({
                            next: (data: MarketData[]) => {
                                let max = data[0];
                                let min = data[0];
                                for (let i = 1; i < data.length; i++) {
                                    if (data[i].change > max.change) {
                                        max = data[i];
                                    } else if (data[i].change < min.change) {
                                        min = data[i];
                                    }
                                }
                                data.splice(data.indexOf(min), 1);
                                data.splice(data.indexOf(max), 1);
                                let max1 = data[0];
                                let min1 = data[0];
                                for (let i = 1; i < data.length; i++) {
                                    if (data[i].change > max1.change) {
                                        max1 = data[i];
                                    } else if (data[i].change < min1.change) {
                                        min1 = data[i];
                                    }
                                }
                                array.push(max, max1, min, min1);
                                this.dataSource.data = array;
                            },
                        });
                },
            });
    }
    masquerPopulaire() {
        if (this.populaires) {
            this.populaires = false;
        } else {
            this.populaires = true;
            this.watchlist = false;
        }
    }

    afficherWatchlist() {
        if (!this.loginService.getIsLogged()) {
            this.dialog.open(PopupLoginComponent);
        } else {
            if (this.watchlist) {
                this.watchlist = false;
            } else {
                this.watchlist = true;
                this.populaires = false;
            }
        }
    }
    openWatchlist() {
        if (!this.loginService.getIsLogged()) {
            this.dialog.open(PopupLoginComponent);
        } else {
            this.dialog.open(PopupWatchlistComponent);
            this.dialog.afterAllClosed.subscribe(() => {
                this.recupererWatchlist();
            });
        }
    }
}
